module.exports = __webpack_public_path__ + "fonts/9062dc5c5fcde652ab1591e75b823fab.svg";